import { render, staticRenderFns } from "./g1-mail.vue?vue&type=template&id=35606eb6&scoped=true&"
import script from "./g1-mail.vue?vue&type=script&lang=js&"
export * from "./g1-mail.vue?vue&type=script&lang=js&"
import style0 from "./g1-mail.vue?vue&type=style&index=0&id=35606eb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35606eb6",
  null
  
)

export default component.exports